module.exports = __webpack_public_path__ + "static/media/Maintain-Safe-Workplace.4ba8ca85.pdf";